/** @module                         Hooks */

import { 
    
    useRef, 
    
    useState, 
    
    useEffect }                     from "react";

import useFetch                     from "../../../Hooks/useFetch";

import useUpdate                    from "../../../Hooks/Mutations/useUpdate";

import { useTranslation }           from "react-i18next";

/** @module                         Queries */

import { MANUFACTURERS_MARKUP }     from "../../../Queries/Markups";

/** @module                         Mutations */

import { UPDATE_MANUFACTURER }      from "../../../Mutations/Manufacturers";

/** @module                         React-Icons */

import { MdOutlineUpdate }          from "react-icons/md";

import { ImSpinner5 }               from "react-icons/im";

/** @module                         Components */

import { Link, useParams }                     from "react-router-dom";

import ComponentLoader              from "../../../Components/Dashboard/Loaders/ComponentLoader";

import Pagination                   from "../../../Components/Dashboard/Global/Table/Pagination";

import { FiEdit } from "react-icons/fi";

const 

SeasonMarkup = () => { const

    /** 
     * 
     * 
     * @event useFetch 
     * 
     * @returns query data, loading state
     * 
     */

    { discountGroup } = useParams(),

    [fieldName, setFieldName] = useState(''),

    { loading, data, refetch } = useFetch ( MANUFACTURERS_MARKUP, { 
        
        first: JSON.parse ( localStorage.getItem ( `manufacturersCollectionCount` ) ) || 12
    
    }, "cache-and-network" );

    useEffect ( () => {
        switch ( discountGroup ) {

            case 'default': 
                setFieldName('attributedMarkup');
                break;

            case 'groupA':
                setFieldName('attributedMarkupGroupA');
                break;

            case 'groupB':
                setFieldName('attributedMarkupGroupB');
                break;

            case 'groupC':
                setFieldName('attributedMarkupGroupC');
                break;

            default: 
                setFieldName('attributedMarkup')
        }
     }, [ discountGroup ] );

    /** @returns */

    return (

        loading ? <ComponentLoader /> : <MarkupTable data={ data } refetch={ refetch } loading={ loading } fieldName={fieldName} />
    )
},

MarkupTable = ( { data, refetch, loading, fieldName } ) => { const { t } = useTranslation ();

    /** @returns */

    return (

        <section className="content__vertical-spacer">

            { ( typeof data != "undefined" ) &&
                
                <Pagination 

                    stringSearch={ true }
                    
                    pageinfo={ data.adminManufacturers.pageInfo } 
                    
                    action={ refetch } 
                    
                    cookie={ `manufacturersCollectionCount` } /> 
            
            }

            <table>

                <thead>

                    <tr>

                        <th>{ t ( "manufacturer" ) }</th>

                        <th>{ t ( "updatedAt" ) }</th>

                        <th>{ t ( "summer" ) }</th>

                        <th>{ t ( "winter" ) }</th>

                        <th>{ t ( "save" ) }</th>

                    </tr>

                </thead>

                <tbody>

                    { data.adminManufacturers.edges.map 
                    
                        ( 
                            
                            ( row, index ) =>

                            <Row key={ index } row={ row } loading={ loading } fieldName={ fieldName } />

                        )

                    }

                </tbody>

            </table>

            { ( typeof data != "undefined" ) &&
                
                <Pagination 
                    
                    pageinfo={ data.adminManufacturers.pageInfo } 
                    
                    action={ refetch } 
                    
                    cookie={ `manufacturersCollectionCount` } /> 
            
            }

        </section>

    );

},

Row = ( { row, index, loading, fieldName } ) => { const { t } = useTranslation (),

    summerReference = useRef ( row.node[fieldName].summer ),

    winterReference = useRef ( row.node[fieldName].winter ),

    /** @event useState form fields */

    [ state, setState ] = useState ( {

        id : row.node.id,

        summerMarkup : row.node[fieldName].summer,

        winterMarkup : row.node[fieldName].winter,

        name : row.node.name

    } ),

    /** @callback useUpdate update mutation hook */

    { 
        
        updateMutation, 
        
        loading: updateLoading
    
    } = useUpdate ( UPDATE_MANUFACTURER ),

    /** 
     * 
     * @param { Object } e
     * 
     * @event handleChange 
     * 
     */

    handleChange = e => { const { name, value } = e.target;

        setState ( prev => ( { ...prev, [ name ]: ( isNaN ( parseFloat ( value ) ) ? "" : parseFloat ( value ) ) } ) );

    },

    /**
     * 
     * @param { Object } e
     * 
     * @event onSubmit
     * 
     * @returns update mutation
     * 
     * @todo updateMutation
     * 
     */

    onSubmit = e => { e.preventDefault ();

        summerReference.current = state.summerMarkup;

        winterReference.current = state.winterMarkup;

        updateMutation ( attributedMarkup ( state, fieldName ) );

    };

    useEffect ( () => { 

        summerReference.current = row.node[fieldName].summer;

        winterReference.current = row.node[fieldName].winter;
        
        setState ( {

            id : row.node.id,

            summerMarkup : row.node[fieldName].summer,

            winterMarkup : row.node[fieldName].winter,

            name : row.node.name

        } ) 

    }, [ row, fieldName ] );

    /** @returns */

    return (

        <tr key={ index }>

            <td>

                <Link to={ `/app/shop/manufacturers/edit/${ row.node.id }` }>

                    { capitalize ( row.node.name ) }
                
                </Link>
                
            </td>

            <td>{ 
            
                new Date ( 
                        
                    row.node.updatedAt 
                    
                ).toLocaleString ().replace(/\//g, '-')
                
            }</td>

            <td>

                <input 
                
                    type="number"

                    name="summerMarkup"

                    min={ 0 }

                    disabled={ loading }

                    value={ state.summerMarkup }

                    onChange={ handleChange }
                
                />
                
            </td>

            <td>

                <input 
                
                    type="number"

                    name="winterMarkup"

                    min={ 0 }

                    disabled={ loading }

                    value={ state.winterMarkup }

                    onChange={ handleChange }
                
                />
                
            </td>

            <td>

                <button

                    onClick={ onSubmit }
                
                    disabled={ ( summerReference.current == state.summerMarkup && winterReference.current == state.winterMarkup || updateLoading ) }
                
                >

                    { updateLoading ? <ImSpinner5 className="spinner" /> : <MdOutlineUpdate />   }

                    <span>

                        { t ( "save" ) }

                    </span>

                </button>

            </td>

        </tr>

    );

},

/**
 * 
 * @param { String } str
 * 
 * @returns capitalized string
 * 
 */

capitalize = str => str.replace ( /\w\S*/g, txt => txt.charAt ( 0 ).toUpperCase () + txt.substr ( 1 ).toLowerCase () ),

/**
 * 
 * @param { Object } state
 * 
 * @returns state object
 * 
 * @todo remove summerMarkup and winterMarkup
 * 
 * @todo add attributedMarkup
 * 
 */

attributedMarkup = (state, fieldName) => { const 

    { summerMarkup, winterMarkup } = state,

    stateObject = ( { ...state, [fieldName] : { summer: summerMarkup, winter: winterMarkup } } );

    /** @todo remove summerMarkup and winterMarkup */

    delete stateObject.summerMarkup;

    delete stateObject.winterMarkup;

    /** @returns state object */

    return stateObject;

};

/** @exports SeasonMarkup */
 
export default SeasonMarkup;